import React from "react";
import "../styles.scss";

export default function BonusDrawContainer({ children }) {
  return <div className='bonus-draw'>{children}</div>;
}
